module.exports = __webpack_public_path__ + "img/sorento-19.d4c72396.png";